<div
    class="full-height-min full-height relative flex min-w-full flex-col bg-white">
    <div class="flex flex-col justify-center">
        <div class="mx-auto w-full max-w-screen-md">
            @if (!invalidCode) {
                <div class="text-white">
                    <app-manual-video
                        [additionalClasses]="[
                            'responsive-video-wide',
                            'rounded-br-faxl',
                        ]"
                        [additionalVideoClasses]="[
                            'responsive-content',
                            'rounded-br-faxl',
                        ]"
                        mp4src="/media/og/referral_720p.mp4"
                        poster="/media/og/friends-collective.jpg"
                        [preload]="true">
                    </app-manual-video>
                </div>
            } @else {
                <h1 class="text-white">Invite Code Invalid!</h1>
            }
        </div>
    </div>
    @if (!invalidCode) {
        <div class="no-shrink-flexer-col mx-auto w-full max-w-screen-md">
            <div class="avatar-container z-10">
                <img
                    src="{{
                        (referredBy | async)?.profilePictureThumbnail ||
                            '/assets/images/anonymous.svg'
                    }}" />
            </div>
            <div class="flexer-col invite-container justify-around px-6">
                <div>
                    {{ (referredBy | async)?.firstname }} has invited you to
                    become a Follow Alice member!
                </div>
                <div>
                    Join our community and meet other travel lovers from around
                    the globe.
                </div>
                <div>
                    You’ll receive <b class="text-red">$100</b> in travel credit
                    as a welcome gift!
                </div>

                <a [routerLink]="['/create-an-account']">
                    <button class="bg-red text-white">Join the party</button>
                </a>

                <div class="hashtag">#travel<b>with</b>friends</div>

                <div class="followalice-logo"></div>
            </div>
        </div>
    }
</div>
